document.addEventListener('DOMContentLoaded', function() {
    // Track current sort state
    let currentSort = {
      field: 'gallons',
      direction: 'ascending'
    };
    
    // Track current tank type as part of filter values
    let currentTankType = 'fresh-water';
  
    // Flag to track if user has interacted with Tank Finder
    let userInteracted = false;
  
    // Function to set a user attribute for tank finder interaction
    function setTankFinderAttribute() {
      // Only set this once per session
      if (userInteracted) return;
      
      userInteracted = true;
      
      // Set user attribute via AJAX call
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Used_Tank_Finder': 'True'
          }
        })
      })
      .then(response => response.json())
      .catch(error => console.error('Error setting Tank Finder attribute:', error));
    }
  
    // Cache DOM elements
    const tabButtons = document.querySelectorAll('.tab-btn');
    const productRows = document.querySelectorAll('.product-row');
    const visibleCount = document.getElementById('visibleCount');
    const totalCount = document.getElementById('totalCount');
    const successMessage = document.getElementById('successMessage');
    const sortableHeaders = document.querySelectorAll('.sortable');
  
    // Cache DOM elements for filter components
    const filterPills = document.querySelectorAll('.filter-pill');
    const filterModal = document.getElementById('filterModal');
    const modalTitle = document.getElementById('modalTitle');
    const closeButton = document.querySelector('.close-button');
    const minSlider = document.getElementById('minSlider');
    const maxSlider = document.getElementById('maxSlider');
    const minInput = document.getElementById('minInput');
    const maxInput = document.getElementById('maxInput');
    const minValueLabel = document.getElementById('minValueLabel');
    const maxValueLabel = document.getElementById('maxValueLabel');
    const clearFilterBtn = document.getElementById('clearFilterBtn');
    const applyFilterBtn = document.getElementById('applyFilterBtn');
    
    // Tank type selector elements
    const tankTypeSelector = document.getElementById('tankTypeSelector');
    const sliderContainer = document.getElementById('sliderContainer');
    const tankTypeAll = document.getElementById('tankTypeAll');
    const tankTypeFresh = document.getElementById('tankTypeFresh');
    const tankTypeHolding = document.getElementById('tankTypeHolding');
    
    // Store filter values
    const filterValues = {
      'tank-type': { value: 'fresh-water' },
      gallons: { min: '', max: '', unit: 'gal' },
      length: { min: '', max: '', unit: 'in' },
      width: { min: '', max: '', unit: 'in' },
      height: { min: '', max: '', unit: 'in' }
    };
    
    // Track current filter being modified
    let currentFilter = '';
    
    // Define filter ranges (dynamically calculated from products)
    const filterRanges = {
      gallons: { min: 0, max: 100 },
      length: { min: 0, max: 100 },
      width: { min: 0, max: 50 },
      height: { min: 0, max: 50 }
    };
    
    // Calculate ranges from products
    function calculateFilterRanges() {
      productRows.forEach(row => {
        // Skip out of stock products
        if (row.dataset.stockStatus !== 'in-stock') return;
        
        const gallons = parseFloat(row.dataset.gallons) || 0;
        const length = parseFloat(row.dataset.length) || 0;
        const width = parseFloat(row.dataset.width) || 0;
        const height = parseFloat(row.dataset.height) || 0;
        
        // Update gallons range
        if (gallons > 0) {
          filterRanges.gallons.min = Math.min(filterRanges.gallons.min, gallons);
          filterRanges.gallons.max = Math.max(filterRanges.gallons.max, gallons);
        }
        
        // Update length range
        if (length > 0) {
          filterRanges.length.min = Math.min(filterRanges.length.min, length);
          filterRanges.length.max = Math.max(filterRanges.length.max, length);
        }
        
        // Update width range
        if (width > 0) {
          filterRanges.width.min = Math.min(filterRanges.width.min, width);
          filterRanges.width.max = Math.max(filterRanges.width.max, width);
        }
        
        // Update height range
        if (height > 0) {
          filterRanges.height.min = Math.min(filterRanges.height.min, height);
          filterRanges.height.max = Math.max(filterRanges.height.max, height);
        }
      });
      
      // Round and adjust ranges for better UX
      Object.keys(filterRanges).forEach(filter => {
        const range = filterRanges[filter];
        range.min = Math.floor(range.min);
        range.max = Math.ceil(range.max);
        
        // Ensure we have a reasonable range
        if (range.max <= range.min) {
          range.max = range.min + 10;
        }
      });
    }
    
    // Update pill appearance based on active filters
    function updateFilterPills() {
      filterPills.forEach(pill => {
        const filter = pill.dataset.filter;
        
        if (filter === 'tank-type') {
          // Handle tank type pill differently
          const tankType = filterValues[filter].value;
          if (tankType === 'all') {
            pill.textContent = 'Type: All';
            pill.classList.add('active');
          } else if (tankType === 'fresh-water') {
            pill.textContent = 'Type: Fresh Water';
            pill.classList.add('active');
          } else if (tankType === 'holding') {
            pill.textContent = 'Type: Holding';
            pill.classList.add('active');
          } else {
            pill.textContent = 'Type';
            pill.classList.remove('active');
          }
        } else {
          // Handle other numeric filters
          const values = filterValues[filter];
          
          if (values.min !== '' || values.max !== '') {
            // Filter is active
            pill.classList.add('active');
            
            // Show filter values on pill
            let pillText = filter.charAt(0).toUpperCase() + filter.slice(1);
            
            if (values.min !== '' && values.max !== '') {
              pillText += `: ${values.min}-${values.max}${values.unit}`;
            } else if (values.min !== '') {
              pillText += `: >${values.min}${values.unit}`;
            } else if (values.max !== '') {
              pillText += `: <${values.max}${values.unit}`;
            }
            
            pill.textContent = pillText;
        } else {
            // Filter not active
            pill.classList.remove('active');
            pill.textContent = filter.charAt(0).toUpperCase() + filter.slice(1);
          }
        }
      });
    }
    
    // Debounce function to limit how often we recalculate
    function debounce(func, wait) {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
    
    // Function to count matches based on current filter settings
    function updateLiveFilterCount() {
      // Clone current filter values
      const tempFilterValues = JSON.parse(JSON.stringify(filterValues));
      
      // Update with current slider values for the active filter
      if (currentFilter && currentFilter !== 'tank-type') {
        tempFilterValues[currentFilter].min = parseInt(minSlider.value);
        tempFilterValues[currentFilter].max = parseInt(maxSlider.value);
      } else if (currentFilter === 'tank-type') {
        // For tank type, get the currently selected radio button
        if (tankTypeAll.checked) {
          tempFilterValues['tank-type'].value = 'all';
        } else if (tankTypeFresh.checked) {
          tempFilterValues['tank-type'].value = 'fresh-water';
        } else if (tankTypeHolding.checked) {
          tempFilterValues['tank-type'].value = 'holding';
        }
      }
      
      // Count matching products with these temporary values
      let matchCount = 0;
      
      productRows.forEach(row => {
        const tankType = row.dataset.tankType;
        const stockStatus = row.dataset.stockStatus;
        const gallons = parseFloat(row.dataset.gallons) || 0;
        const length = parseFloat(row.dataset.length) || 0;
        const width = parseFloat(row.dataset.width) || 0;
        const height = parseFloat(row.dataset.height) || 0;
        
        // Always check if product is in stock
        const isInStock = stockStatus === 'in-stock';
        
        // Check if this row matches all current filters
        const matchesTankType = tempFilterValues['tank-type'].value === 'all' || 
                               tankType === tempFilterValues['tank-type'].value || 
                               tankType === 'unknown';
        
        const matchesGallons = (tempFilterValues.gallons.min === '' || gallons >= tempFilterValues.gallons.min) && 
                              (tempFilterValues.gallons.max === '' || gallons <= tempFilterValues.gallons.max);
        
        const matchesLength = (tempFilterValues.length.min === '' || length >= tempFilterValues.length.min) && 
                             (tempFilterValues.length.max === '' || length <= tempFilterValues.length.max);
        
        const matchesWidth = (tempFilterValues.width.min === '' || width >= tempFilterValues.width.min) && 
                            (tempFilterValues.width.max === '' || width <= tempFilterValues.width.max);
        
        const matchesHeight = (tempFilterValues.height.min === '' || height >= tempFilterValues.height.min) && 
                             (tempFilterValues.height.max === '' || height <= tempFilterValues.height.max);
        
        // Only count in-stock products that match all filters
        if (isInStock && matchesTankType && matchesGallons && matchesLength && matchesWidth && matchesHeight) {
          matchCount++;
        }
      });
      
      // Update the apply button text with the count
      if (applyFilterBtn) {
        applyFilterBtn.textContent = `View ${matchCount} Result${matchCount !== 1 ? 's' : ''}`;
        
        // Add a highlight effect to the button when the count changes
        applyFilterBtn.classList.add('updated');
        
        // Remove the highlight after a brief delay
        setTimeout(() => {
          applyFilterBtn.classList.remove('updated');
        }, 300);
      }
    }
    
    // Create a debounced version to avoid excessive calculations
    const debouncedUpdateLiveCount = debounce(updateLiveFilterCount, 150);
    
    // Setup filter UI based on selected filter
    function setupFilterForType(filter) {
      currentFilter = filter;
      
      // Update modal title
      modalTitle.textContent = filter === 'tank-type' ? 'Tank Type' : 
        filter.charAt(0).toUpperCase() + filter.slice(1);
      
      // Reset apply button text
      applyFilterBtn.textContent = 'Apply';
      
      if (filter === 'tank-type') {
        // Show tank type selector, hide slider
        tankTypeSelector.style.display = 'block';
        sliderContainer.style.display = 'none';
        
        // Set the correct radio button based on current selection
        const currentValue = filterValues['tank-type'].value;
        if (currentValue === 'all') {
          tankTypeAll.checked = true;
        } else if (currentValue === 'fresh-water') {
          tankTypeFresh.checked = true;
        } else if (currentValue === 'holding') {
          tankTypeHolding.checked = true;
        }
        
        // Update the filter count for tank type
        updateLiveFilterCount();
      } else {
        // Show slider, hide tank type selector
        tankTypeSelector.style.display = 'none';
        sliderContainer.style.display = 'block';
        
        // Setup numeric filter slider
        setupSliderForFilter(filter);
      }
      
      // Show the modal
      filterModal.style.display = 'block';
    }
    
    // Setup slider for current numeric filter
    function setupSliderForFilter(filter) {
      const range = filterRanges[filter];
      const values = filterValues[filter];
      const unit = values.unit;
      
      // Configure sliders
      minSlider.min = range.min;
      minSlider.max = range.max;
      maxSlider.min = range.min;
      maxSlider.max = range.max;
      
      // Set current values or defaults
      minSlider.value = values.min !== '' ? values.min : range.min;
      maxSlider.value = values.max !== '' ? values.max : range.max;
      
      // Update inputs
      minInput.min = range.min;
      minInput.max = range.max;
      maxInput.min = range.min;
      maxInput.max = range.max;
      minInput.value = minSlider.value;
      maxInput.value = maxSlider.value;
      
      // Update labels
      minValueLabel.textContent = `${minSlider.value}${unit}`;
      maxValueLabel.textContent = `${maxSlider.value}${unit}`;
      
      // Update slider track
      updateSliderTrack();
    }
    
    // Update slider track appearance
    function updateSliderTrack() {
      const range = maxSlider.max - minSlider.min;
      const minPosition = ((minSlider.value - minSlider.min) / range) * 100;
      const maxPosition = ((maxSlider.value - minSlider.min) / range) * 100;
      
      const track = document.querySelector('.slider-track');
      track.style.background = `linear-gradient(to right, 
        #e0e0e0 0%, 
        #e0e0e0 ${minPosition}%, 
        #e20000 ${minPosition}%, 
        #e20000 ${maxPosition}%, 
        #e0e0e0 ${maxPosition}%, 
        #e0e0e0 100%)`;
    }
    
    // Function to save filter settings to URL
    function updateURL() {
      const params = new URLSearchParams();
      
      // Save tank type
      if (filterValues['tank-type'].value) {
        params.set('tank-type', filterValues['tank-type'].value);
      }
      
      // Save numeric filters (only if they have values)
      ['gallons', 'length', 'width', 'height'].forEach(filter => {
        if (filterValues[filter].min !== '') {
          params.set(`${filter}-min`, filterValues[filter].min);
        }
        if (filterValues[filter].max !== '') {
          params.set(`${filter}-max`, filterValues[filter].max);
        }
      });
      
      // Save sort state if it exists
      if (currentSort.field) {
        params.set('sort', currentSort.field);
        params.set('direction', currentSort.direction);
      }
      
      // Update the URL without refreshing the page
      const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
      window.history.replaceState({}, '', newURL);
    }
    
    // Function to load filter settings from URL
    function loadFiltersFromURL() {
      const params = new URLSearchParams(window.location.search);
      
      // Load tank type
      if (params.has('tank-type')) {
        const tankType = params.get('tank-type');
        if (['all', 'fresh-water', 'holding'].includes(tankType)) {
          filterValues['tank-type'].value = tankType;
        }
      }
      
      // Load numeric filters
      ['gallons', 'length', 'width', 'height'].forEach(filter => {
        if (params.has(`${filter}-min`)) {
          filterValues[filter].min = parseInt(params.get(`${filter}-min`));
        }
        if (params.has(`${filter}-max`)) {
          filterValues[filter].max = parseInt(params.get(`${filter}-max`));
        }
      });
      
      // Load sort state
      if (params.has('sort')) {
        currentSort.field = params.get('sort');
        currentSort.direction = params.has('direction') ? params.get('direction') : 'ascending';
        updateSortArrows();
      }
    }
    
    // Modified applyFilter function that also sets the attribute
    function applyFilter() {
      if (currentFilter === 'tank-type') {
        // Get selected tank type
        if (tankTypeAll.checked) {
          filterValues['tank-type'].value = 'all';
        } else if (tankTypeFresh.checked) {
          filterValues['tank-type'].value = 'fresh-water';
        } else if (tankTypeHolding.checked) {
          filterValues['tank-type'].value = 'holding';
        }
      } else {
        // Store numeric filter values
        filterValues[currentFilter].min = parseInt(minSlider.value);
        filterValues[currentFilter].max = parseInt(maxSlider.value);
      }
      
      // Set user attribute when filter is applied
      setTankFinderAttribute();
      
      // Close the modal
      filterModal.style.display = 'none';
      
      // Update pill appearance
      updateFilterPills();
      
      // Apply filters to rows
      filterRows();
      
      // Update URL with current filter settings
      updateURL();
      
      // Reset apply button text
      applyFilterBtn.textContent = 'Apply';
    }
    
    // Modified clearFilter function to update the URL
    function clearFilter() {
      if (currentFilter === 'tank-type') {
        // Reset to default tank type (fresh water)
        filterValues['tank-type'].value = 'fresh-water';
        tankTypeFresh.checked = true;
      } else {
        // Clear numeric filter
        filterValues[currentFilter].min = '';
        filterValues[currentFilter].max = '';
      }
      
      // Close the modal
      filterModal.style.display = 'none';
      
      // Update pill appearance
      updateFilterPills();
      
      // Apply filters to rows
      filterRows();
      
      // Update URL with current filter settings
      updateURL();
      
      // Reset apply button text
      applyFilterBtn.textContent = 'Apply';
    }
  
    // Updated filterRows function to always hide out of stock items
    function filterRows() {
      const selectedTankType = filterValues['tank-type'].value;
  
      let visibleProductCount = 0;
      let totalAvailableCount = 0;
      const noResultsRow = document.getElementById('noResultsRow');
      if (noResultsRow) noResultsRow.remove();
  
      productRows.forEach(row => {
        const tankType = row.dataset.tankType;
        const stockStatus = row.dataset.stockStatus;
        
        const gallons = parseFloat(row.dataset.gallons) || 0;
        const length = parseFloat(row.dataset.length) || 0;
        const width = parseFloat(row.dataset.width) || 0;
        const height = parseFloat(row.dataset.height) || 0;
  
        // Always check stock status - hide out of stock items
        const isInStock = stockStatus === 'in-stock';
        
        // Check tank type
        const matchesTankType = selectedTankType === 'all' || tankType === selectedTankType || tankType === 'unknown';
        
        // Only count in-stock products that match the tank type for the total
        if (matchesTankType && isInStock) {
          totalAvailableCount++;
        }
  
        // Check each dimension against filter values
        const matchesGallons = (filterValues.gallons.min === '' || gallons >= filterValues.gallons.min) && 
                               (filterValues.gallons.max === '' || gallons <= filterValues.gallons.max);
        
        const matchesLength = (filterValues.length.min === '' || length >= filterValues.length.min) && 
                             (filterValues.length.max === '' || length <= filterValues.length.max);
        
        const matchesWidth = (filterValues.width.min === '' || width >= filterValues.width.min) && 
                            (filterValues.width.max === '' || width <= filterValues.width.max);
        
        const matchesHeight = (filterValues.height.min === '' || height >= filterValues.height.min) && 
                             (filterValues.height.max === '' || height <= filterValues.height.max);
        
        // Include stock status in visibility check
        const isVisible = isInStock && matchesTankType && matchesGallons && matchesLength && 
                          matchesWidth && matchesHeight;
        
        row.style.display = isVisible ? '' : 'none';
        
        if (isVisible) visibleProductCount++;
      });
  
      // Update counts and no results message
      if (visibleCount) {
        visibleCount.textContent = visibleProductCount;
      }
      
      if (totalCount) {
        totalCount.textContent = totalAvailableCount;
      }
  
      if (visibleProductCount === 0) {
        const tbody = document.getElementById('productTableBody');
        const newRow = document.createElement('tr');
        newRow.id = 'noResultsRow';
        
        const isMobile = window.innerWidth <= 768;
        newRow.innerHTML = `<td colspan="${isMobile ? 5 : 9}">No products match your filter criteria.</td>`;
        
        tbody.appendChild(newRow);
      }
    }
  
    // Helper function to show success message
    function showSuccessMessage(message) {
      successMessage.textContent = message;
      successMessage.style.display = 'block';
      
      // Hide after animation completes
      setTimeout(() => {
        successMessage.style.display = 'none';
      }, 4000);
    }
  
    // Modified add to cart click handler
    document.querySelectorAll('.add-to-cart-btn').forEach(button => {
      button.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        const quantity = 1; // Always add 1 item
        
        // Set user attribute when adding to cart
        setTankFinderAttribute();
        
        // Add loading state
        this.classList.add('loading');
        const originalText = this.textContent;
        this.textContent = 'Adding...';
        
        // Use the Shopify AJAX API for cart additions with attribute
        const formData = {
          'items': [{
            'id': variantId,
            'quantity': quantity
          }],
          'attributes': {
            'Used_Tank_Finder': 'True'
          }
        };
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(item => {
          // Reset button state
          this.classList.remove('loading');
          this.textContent = originalText;
          
          // Show success message
          showSuccessMessage('Item added to cart!');
          
          // Update the cart - critical part that matches Elkhart RV Parts
          fetchCart();
        })
        .catch(error => {
          console.error('Error:', error);
          this.classList.remove('loading');
          this.textContent = originalText;
          alert('Error adding item to cart');
        });
      });
    });
  
    // Function to fetch and update cart that matches Elkhart RV Parts implementation
    function fetchCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Update cart count in header
          updateCartCount(cart.item_count);
          
          // This is the key part - refresh the cart drawer HTML
          // This matches how the Elkhart RV Parts site updates its cart
          if (window.Shopify && window.Shopify.theme) {
            if (typeof window.Shopify.theme.sections !== 'undefined') {
              // For Dawn and similar themes
              document.querySelector('cart-drawer')?.refreshCart?.();
              document.querySelector('cart-notification')?.updateQuantity?.(cart.item_count);
            }
            
            // Send an event the theme might listen for
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cart }
              })
            );
          }
          
          // Try to directly update any cart drawer that might be on the page
          const cartDrawers = document.querySelectorAll('.cart-drawer, .mini-cart, #cart-drawer, [data-section-id="cart-drawer"]');
          if (cartDrawers.length > 0) {
            fetch('/?sections=cart-drawer,mini-cart')
              .then(response => response.text())
              .then(text => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;
                
                // Try to find and replace the cart drawer content
                cartDrawers.forEach(drawer => {
                  const sectionId = drawer.dataset.sectionId || 'cart-drawer';
                  const newContent = tempDiv.querySelector(`[data-section-id="${sectionId}"]`);
                  if (newContent) {
                    drawer.innerHTML = newContent.innerHTML;
                  }
                });
              })
              .catch(error => console.error('Error fetching cart drawer:', error));
          }
          
          // For themes with a side drawer cart that needs to be opened
          const cartTrigger = document.querySelector('.cart-icon-bubble, .cart-count-bubble, [data-action="open-drawer"][data-drawer-id="cart"]');
          if (cartTrigger && typeof cartTrigger.click === 'function') {
            setTimeout(() => {
              cartTrigger.click();
            }, 300);
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }
  
    // Update cart count indicators (matches approach on ElkhartRVParts)
    function updateCartCount(count) {
      // Update all possible cart count elements
      document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count], #CartCount').forEach(el => {
        if (el) {
          el.textContent = count;
          
          // Handle the cart bubble visibility
          const bubble = el.closest('.cart-count-bubble');
          if (bubble) {
            bubble.classList.toggle('hide', count === 0);
          }
        }
      });
      
      // Ensure cart icon shows the right state (empty or not)
      document.querySelectorAll('.cart-icon-bubble, .cart-count-bubble').forEach(icon => {
        if (icon) {
          if (count > 0) {
            icon.classList.remove('is-empty');
          } else {
            icon.classList.add('is-empty');
          }
        }
      });
    }
  
    // Add event listeners for filter pills
    filterPills.forEach(pill => {
      pill.addEventListener('click', () => {
        setupFilterForType(pill.dataset.filter);
      });
    });
    
    // Close modal when clicking the X
    closeButton.addEventListener('click', () => {
      filterModal.style.display = 'none';
      // Reset apply button text
      applyFilterBtn.textContent = 'Apply';
    });
    
    // Close modal when clicking outside
    window.addEventListener('click', (event) => {
      if (event.target === filterModal) {
        filterModal.style.display = 'none';
        // Reset apply button text
        applyFilterBtn.textContent = 'Apply';
      }
    });
    
    // Handle slider interactions
    minSlider.addEventListener('input', function() {
      if (parseInt(minSlider.value) > parseInt(maxSlider.value)) {
        minSlider.value = maxSlider.value;
      }
      minInput.value = minSlider.value;
      minValueLabel.textContent = `${minSlider.value}${filterValues[currentFilter].unit}`;
      updateSliderTrack();
      
      // Add live count update
      debouncedUpdateLiveCount();
    });
    
    maxSlider.addEventListener('input', function() {
      if (parseInt(maxSlider.value) < parseInt(minSlider.value)) {
        maxSlider.value = minSlider.value;
      }
      maxInput.value = maxSlider.value;
      maxValueLabel.textContent = `${maxSlider.value}${filterValues[currentFilter].unit}`;
      updateSliderTrack();
      
      // Add live count update
      debouncedUpdateLiveCount();
    });
    
    // Sync number inputs with sliders
    minInput.addEventListener('change', function() {
      let value = parseInt(minInput.value);
      
      if (isNaN(value)) {
        value = parseInt(minSlider.min);
      }
      
      if (value > parseInt(maxSlider.value)) {
        value = parseInt(maxSlider.value);
      }
      
      minSlider.value = value;
      minInput.value = value;
      minValueLabel.textContent = `${value}${filterValues[currentFilter].unit}`;
      updateSliderTrack();
      
      // Add live count update
      debouncedUpdateLiveCount();
    });
    
    maxInput.addEventListener('change', function() {
      let value = parseInt(maxInput.value);
      
      if (isNaN(value)) {
        value = parseInt(maxSlider.max);
      }
      
      if (value < parseInt(minSlider.value)) {
        value = parseInt(minSlider.value);
      }
      
      maxSlider.value = value;
      maxInput.value = value;
      maxValueLabel.textContent = `${value}${filterValues[currentFilter].unit}`;
      updateSliderTrack();
      
      // Add live count update
      debouncedUpdateLiveCount();
    });
    
    // Apply and Clear filter buttons
    applyFilterBtn.addEventListener('click', applyFilter);
    clearFilterBtn.addEventListener('click', clearFilter);
    
    // Calculate ranges from products on page load
    calculateFilterRanges();
  
    // Update sort arrows based on current sort state
    function updateSortArrows() {
      sortableHeaders.forEach(header => {
        const arrow = header.querySelector('.sort-arrow');
        const sortField = header.dataset.sort;
        
        if (sortField === currentSort.field) {
          arrow.textContent = currentSort.direction === 'ascending' ? '↑' : '↓';
          arrow.classList.add('active');
    } else {
          arrow.textContent = '';
          arrow.classList.remove('active');
        }
      });
    }
  
    // Modified sortProducts to set attribute
    function sortProducts(field) {
      // Set user attribute when sorting
      setTankFinderAttribute();
      
      // Update sort state
      if (field) {
        if (currentSort.field === field) {
          // Toggle direction if same field
          currentSort.direction = currentSort.direction === 'ascending' ? 'descending' : 'ascending';
        } else {
          // New field, default to ascending
          currentSort.field = field;
          currentSort.direction = 'ascending';
        }
        
        // Set method for sorting
        const method = field + '-' + currentSort.direction;
        
        // Update sort arrows
        updateSortArrows();
        
        // Perform the sort
        const tbody = document.getElementById('productTableBody');
        const rows = Array.from(productRows);
        
        if (method === 'price-ascending') {
          rows.sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
        } else if (method === 'price-descending') {
          rows.sort((a, b) => parseFloat(b.dataset.price) - parseFloat(a.dataset.price));
        } else if (method === 'title-ascending') {
          rows.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name));
        } else if (method === 'title-descending') {
          rows.sort((a, b) => b.dataset.name.localeCompare(a.dataset.name));
        } else if (method === 'gallons-ascending') {
          rows.sort((a, b) => (parseFloat(a.dataset.gallons) || 0) - (parseFloat(b.dataset.gallons) || 0));
        } else if (method === 'gallons-descending') {
          rows.sort((a, b) => (parseFloat(b.dataset.gallons) || 0) - (parseFloat(a.dataset.gallons) || 0));
        } else if (method === 'length-ascending') {
          rows.sort((a, b) => (parseFloat(a.dataset.length) || 0) - (parseFloat(b.dataset.length) || 0));
        } else if (method === 'length-descending') {
          rows.sort((a, b) => (parseFloat(b.dataset.length) || 0) - (parseFloat(a.dataset.length) || 0));
        } else if (method === 'width-ascending') {
          rows.sort((a, b) => (parseFloat(a.dataset.width) || 0) - (parseFloat(b.dataset.width) || 0));
        } else if (method === 'width-descending') {
          rows.sort((a, b) => (parseFloat(b.dataset.width) || 0) - (parseFloat(a.dataset.width) || 0));
        } else if (method === 'height-ascending') {
          rows.sort((a, b) => (parseFloat(a.dataset.height) || 0) - (parseFloat(a.dataset.height) || 0));
        } else if (method === 'height-descending') {
          rows.sort((a, b) => (parseFloat(b.dataset.height) || 0) - (parseFloat(a.dataset.height) || 0));
        }
        
        // Re-append rows in new order
        rows.forEach(row => tbody.appendChild(row));
        
        // Re-apply filters after sorting
        filterRows();
      }
      
      // Add this at the end of the function
      updateURL();
    }
  
    // Add click event to sortable headers
    sortableHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const sortField = this.dataset.sort;
        sortProducts(sortField);
      });
    });
  
    // Initial filter update on load
    updateFilterPills();
    filterRows();
  
    // Load any saved filter settings when the page loads
    loadFiltersFromURL();
    
    // After loading filters from URL, proceed with initial setup
    updateFilterPills();
    
    // If sort parameters exist in URL, apply the sort
    if (currentSort.field) {
      // Create a temporary array for sorting
      const tbody = document.getElementById('productTableBody');
      const rows = Array.from(productRows);
      const method = currentSort.field + '-' + currentSort.direction;
      
      // Apply the appropriate sort (reuse the same logic from sortProducts)
      if (method === 'price-ascending') {
        rows.sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
      } 
      // ... include all your other sort methods here ...
      
      // Re-append rows in sorted order
      rows.forEach(row => tbody.appendChild(row));
    }
    
    // Finally apply the filters
    filterRows();

    // Modal functionality for product details
    const productDetailModal = document.getElementById('productDetailModal');
    const detailCloseButton = document.querySelector('.detail-close-button');
    const detailProductTitle = document.getElementById('detailProductTitle');
    const detailGallons = document.getElementById('detailGallons');
    const detailDimensions = document.getElementById('detailDimensions');
    const detailVendor = document.getElementById('detailVendor');
    const detailSku = document.getElementById('detailSku');
    const detailPrice = document.getElementById('detailPrice');
    const detailStock = document.getElementById('detailStock');
    const detailAddToCart = document.getElementById('detailAddToCart');
    const detailViewLink = document.getElementById('detailViewLink');
    const svgContainer = document.querySelector('.product-svg-container');

    // Helper function to decode HTML entities
    function decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }

    // Add event listeners to all magnify icons
    document.querySelectorAll('.magnify-icon').forEach(icon => {
      icon.addEventListener('click', function() {
        // Find the product row
        const row = this.closest('.product-row');
        
        // Get all the product data from the data attributes
        const productTitle = decodeHtml(row.dataset.name);
        const gallons = row.dataset.gallons;
        const length = row.dataset.length;
        const width = row.dataset.width;
        const height = row.dataset.height;
        const tankType = row.dataset.tankType;
        const sku = row.dataset.sku;
        
        // Extract vendor properly - don't split the product name
        const vendor = row.querySelector('td:nth-child(6)')?.textContent.split(' - ')[0] || 
                       row.querySelector('.vendor-sku')?.textContent || 
                       'N/A';
                   
        const price = row.dataset.price;
        const variantId = row.dataset.variantId;
        const productUrl = row.querySelector('a').href;
        const stockStatus = row.dataset.stockStatus;
        
        // Update the modal content
        detailProductTitle.textContent = productTitle;
        detailGallons.textContent = `${gallons} Gallons`;
        detailDimensions.textContent = `L: ${length}", W: ${width}", H: ${height}"`;
        detailVendor.textContent = vendor;
        detailSku.textContent = sku;
        detailPrice.textContent = `$${(price / 100).toFixed(2)}`;
        detailStock.textContent = stockStatus === 'in-stock' ? 'In Stock' : 'Out of Stock';
        
        // Update the add to cart button
        detailAddToCart.dataset.variantId = variantId;
        if (stockStatus !== 'in-stock') {
          detailAddToCart.disabled = true;
          detailAddToCart.textContent = 'Out of Stock';
        } else {
          detailAddToCart.disabled = false;
          detailAddToCart.textContent = 'Add to Cart';
        }
        
        // Update the view product link
        detailViewLink.href = productUrl;
        
        // Generate and display the SVG
        const tankTypePrefix = tankType === 'fresh-water' ? 'fresh_water_tanks' : 'holding_tanks';
        const svgUrl = `https://d3sosgkdp1n1t7.cloudfront.net/${tankTypePrefix}-${length}x${width}x${height}.svg`;
        
        // Create an img element for the SVG
        svgContainer.innerHTML = `<img src="${svgUrl}" alt="${productTitle}" style="max-width:100%; max-height:300px;">`;
        
        // Show the modal
        productDetailModal.style.display = 'block';
      });
    });

    // Close modal when clicking the X
    detailCloseButton.addEventListener('click', () => {
      productDetailModal.style.display = 'none';
    });

    // Close modal when clicking outside
    window.addEventListener('click', (event) => {
      if (event.target === productDetailModal) {
        productDetailModal.style.display = 'none';
      }
    });

    // Modified detail modal add to cart function
    detailAddToCart.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      const quantity = 1;
      
      // Set user attribute
      setTankFinderAttribute();
      
      // Add loading state
      this.classList.add('loading');
      const originalText = this.textContent;
      this.textContent = 'Adding...';
      
      // Use the Shopify AJAX API for cart additions with attribute
      const formData = {
        'items': [{
          'id': variantId,
          'quantity': quantity
        }],
        'attributes': {
          'Used_Tank_Finder': 'True'
        }
      };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(item => {
        // Reset button state
        this.classList.remove('loading');
        this.textContent = originalText;
        
        // Show success message
        showSuccessMessage('Item added to cart!');
        
        // Update the cart
        fetchCart();
        
        // Close the modal
        productDetailModal.style.display = 'none';
      })
      .catch(error => {
        console.error('Error:', error);
        this.classList.remove('loading');
        this.textContent = originalText;
        alert('Error adding item to cart');
      });
    });

    // Add event handler for view details links to set attribute
    document.querySelectorAll('.view-details-link').forEach(link => {
      link.addEventListener('click', function() {
        setTankFinderAttribute();
      });
    });

    // Add event handler for magnify icons to set attribute
    document.querySelectorAll('.magnify-icon').forEach(icon => {
      icon.addEventListener('click', function() {
        setTankFinderAttribute();
      });
    });

    // Initial sort by gallons if no sort parameters in URL
    if (!currentSort.field) {
      currentSort.field = 'gallons';
      currentSort.direction = 'ascending';
    }

    // Apply the initial sort - actually perform the sort operation
    const tbody = document.getElementById('productTableBody');
    const rows = Array.from(productRows);

    // Sort by gallons ascending (smallest to largest)
    rows.sort((a, b) => (parseFloat(a.dataset.gallons) || 0) - (parseFloat(b.dataset.gallons) || 0));

    // Re-append rows in sorted order
    rows.forEach(row => tbody.appendChild(row));

    // Update the sort arrows to match
    updateSortArrows();
  });